var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E9E9E0;}\n\t.st1{fill:#D9D7CA;}\n\t.st2{fill:#F29D5C;}\n\t.st3{fill:#278BB7;}\n\t.st4{fill:#155D9E;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,0H8C7.2,0,6.5,0.7,6.5,1.9V55c0,0.3,0.7,1,1.5,1H48c0.8,0,1.5-0.7,1.5-1V13c0-0.7-0.1-0.9-0.3-1.1 L37.6,0.3C37.4,0.1,37.2,0,37,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.5,0.2 37.5,12 49.3,12  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 18.9,
    cy: 14.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.5,24.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48,56H8c-0.8,0-1.5-0.7-1.5-1.5V39h43v15.5C49.5,55.3,48.8,56,48,56z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.2,43c0.6-0.1,1.5-0.2,2.5-0.2c1.3,0,2.2,0.3,2.8,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,0.9-0.3,1.6-0.8,2.2 c-0.7,0.7-1.8,1.1-3.1,1.1c-0.4,0-0.8,0-1-0.1v4h-1.3V43z M16.5,47.9c0.3,0.1,0.6,0.1,1.1,0.1c1.6,0,2.5-0.8,2.5-2.2 c0-1.3-0.9-2-2.4-2c-0.6,0-1,0-1.2,0.1V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.1,53V42.9h1.4l3.2,5.1c0.8,1.2,1.3,2.2,1.8,3.3l0,0c-0.1-1.3-0.1-2.6-0.1-4.2v-4.2h1.2V53h-1.3l-3.2-5.1 c-0.7-1.1-1.4-2.3-1.9-3.4l0,0c0.1,1.3,0.1,2.5,0.1,4.2V53H23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.7,52.5c-0.6,0.2-1.7,0.6-3.1,0.6c-1.5,0-2.8-0.4-3.8-1.3c-0.9-0.8-1.4-2.2-1.4-3.8c0-3,2.1-5.2,5.5-5.2 c1.2,0,2.1,0.3,2.5,0.5l-0.3,1.1c-0.5-0.2-1.2-0.4-2.2-0.4c-2.5,0-4.1,1.5-4.1,4.1c0,2.6,1.5,4.1,3.9,4.1c0.9,0,1.4-0.1,1.7-0.3v-3 h-2.1v-1h3.3V52.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.e739997d13dd59a2589f64e08d5430ab.svg";
export { ForwardRef as ReactComponent };